$(document).ready(function () {
  const waitForSearchBar = setInterval(() => {
    const searchBar = document.querySelector(".input-group.search-bar");
    if (!searchBar || !searchBar.parentElement) return;
    if (!window.frappe || !frappe.session || !frappe.session.user || frappe.session.user === "Guest") return;

    if (document.getElementById("nav-sales-partner-link-field")) {
      clearInterval(waitForSearchBar);
      return;
    }

    clearInterval(waitForSearchBar);

    const currentUser = frappe.session.user;

    // Check if user changed on this browser, clear stale partner from previous user
    const lastUser = localStorage.getItem("selected_sales_partner_user");
    if (lastUser && lastUser !== currentUser) {
      localStorage.removeItem("selected_sales_partner");
    }
    localStorage.setItem("selected_sales_partner_user", currentUser);

    // Create wrapper
    const fieldWrapper = document.createElement("div");
    fieldWrapper.className = "nav-sales-partner-link-field ml-2 d-none d-lg-block";
    fieldWrapper.id = "nav-sales-partner-link-field";
    fieldWrapper.title = "اختر نقطة المبيعات الافتراضية";
    fieldWrapper.style.minWidth = "200px";

    // Create label element
    const label = document.createElement("span");
    label.className = "sales-partner-label text-muted";
    label.style.cursor = "pointer";
    label.style.fontSize = "0.75rem";
    label.style.padding = "6px 12px";
    label.style.border = "1px solid #ccc";
    label.style.borderRadius = "6px";
    label.style.display = "inline-block";
    label.innerText = "جارٍ التحميل...";

    // Create field container
    const fieldContainer = document.createElement("div");
    fieldContainer.style.display = "none"; // hidden by default

    // Insert elements
    fieldWrapper.appendChild(label);
    fieldWrapper.appendChild(fieldContainer);
    searchBar.parentElement.insertBefore(fieldWrapper, searchBar.nextSibling);

    let current_selected_partner = null;

    function applyPartner(partner, syncSession = true) {
      if (!partner || partner === current_selected_partner) return;
      current_selected_partner = partner;

      if (window.navSalesPartnerField && typeof window.navSalesPartnerField.set_value === "function") {
        window.navSalesPartnerField.set_value(partner);
      }

      label.innerText = `نقطة البيع: ${partner}`;
      localStorage.setItem("selected_sales_partner", partner);
      localStorage.setItem("selected_sales_partner_user", currentUser);

      if (syncSession) {
        frappe.call({
          method: "frappe.core.doctype.session_default_settings.session_default_settings.set_session_default_values",
          args: {
            default_values: {
              sales_partner: partner || "",
              default_sales_partner: partner || ""
            }
          },
          callback: function (r) {
            if (r.message === "success" && frappe.defaults && typeof frappe.defaults.set_user_default_local === "function") {
              frappe.defaults.set_user_default_local("sales_partner", partner || "");
              frappe.defaults.set_user_default_local("default_sales_partner", partner || "");
            }
          }
        });
      }
    }

    // Create Link field
    window.navSalesPartnerField = frappe.ui.form.make_control({
      parent: fieldContainer,
      df: {
        fieldtype: "Link",
        label: "",
        options: "Sales Partner",
        placeholder: "اختر نقطة المبيعات الافتراضية...",
        reqd: 0,
        get_query: function () {
          return {
            order_by: "`tabSales Partner`.modified desc"
          };
        },
        onchange: function () {
          const value = this.get_value();
          // Avoid loop: if empty or already current partner, do nothing
          if (!value || value === current_selected_partner) return;

          current_selected_partner = value;
          label.innerText = `نقطة البيع: ${value}`;
          localStorage.setItem("selected_sales_partner", value);
          localStorage.setItem("selected_sales_partner_user", currentUser);

          fieldContainer.style.display = "none";
          label.style.display = "inline-block";

          frappe.call({
            method: "frappe.core.doctype.session_default_settings.session_default_settings.set_session_default_values",
            args: {
              default_values: {
                sales_partner: value || "",
                default_sales_partner: value || ""
              }
            },
            callback: function (r) {
              if (r.message === "success" && frappe.defaults && typeof frappe.defaults.set_user_default_local === "function") {
                frappe.defaults.set_user_default_local("sales_partner", value || "");
                frappe.defaults.set_user_default_local("default_sales_partner", value || "");
              }
            }
          });
        }
      },
      render_input: true
    });

    // Toggle visibility on label click
    label.addEventListener("click", (e) => {
      e.stopPropagation();
      fieldContainer.style.display = "block";
      label.style.display = "none";
      if (window.navSalesPartnerField && window.navSalesPartnerField.$input) {
        window.navSalesPartnerField.$input.focus();
      }
    });

    // Click outside to collapse back to label
    document.addEventListener("click", (e) => {
      if (!fieldWrapper.contains(e.target)) {
        if (fieldContainer.style.display !== "none") {
          fieldContainer.style.display = "none";
          label.style.display = "inline-block";
        }
      }
    });

    // 1. Check User Permissions for Sales Partner
    const userPermissions = (frappe.defaults && typeof frappe.defaults.get_user_permissions === "function")
      ? (frappe.defaults.get_user_permissions()["Sales Partner"] || [])
      : [];

    if (userPermissions.length > 0) {
      const allowedDocs = userPermissions.map((p) => p.doc);
      const currentSaved = localStorage.getItem("selected_sales_partner");

      if (currentSaved && allowedDocs.includes(currentSaved)) {
        applyPartner(currentSaved, false);
      } else {
        const defaultPerm = userPermissions.find((p) => p.is_default);
        const fallback = defaultPerm ? defaultPerm.doc : allowedDocs[0];
        if (fallback) {
          applyPartner(fallback, true);
        } else {
          label.innerText = "🚫 غير مسموح";
        }
      }
      return;
    }

    // 2. If no User Permission restrictions, check saved partner or session default
    const sessionDefault = (frappe.defaults && typeof frappe.defaults.get_user_default === "function")
      ? (frappe.defaults.get_user_default("sales_partner") || frappe.defaults.get_user_default("default_sales_partner"))
      : null;
    const savedPartner = localStorage.getItem("selected_sales_partner") || sessionDefault;

    if (savedPartner) {
      // Validate that savedPartner actually exists and is readable
      frappe.call({
        method: "frappe.client.get_list",
        args: {
          doctype: "Sales Partner",
          filters: { name: savedPartner },
          fields: ["name"],
          limit_page_length: 1
        },
        callback: function (r) {
          if (!r.exc && r.message && r.message.length > 0) {
            applyPartner(savedPartner, false);
          } else {
            fetchFirstPartner();
          }
        }
      });
    } else {
      fetchFirstPartner();
    }

    function fetchFirstPartner() {
      frappe.call({
        method: "frappe.client.get_list",
        args: {
          doctype: "Sales Partner",
          fields: ["name"],
          order_by: "`tabSales Partner`.modified desc",
          limit_page_length: 1
        },
        callback: function (r) {
          if (r.exc || !r.message || r.message.length === 0) {
            label.innerText = "🚫 غير مسموح";
            return;
          }
          const partner = r.message[0]?.name;
          if (partner) {
            applyPartner(partner, true);
          } else {
            label.innerText = "🚫 غير مسموح";
          }
        }
      });
    }
  }, 300);
});